<template>
  <div class="list-group-item" :class="{ selected }">
    <span v-if="selected"><slot /></span>
    <router-link v-else :to="href" class="flex-grow-1"><slot /></router-link>
  </div>
</template>

<script>
export default {
  props: {
    href: { type: String, default: '' },
  },
  computed: {
    selected() {
      return this.$route?.path === this.href
    }
  }
}
</script>
